import base from './base';

const primaryColor = '#0090d2';
const primary = '#0090d2';
const hover = '#f4c29a';
const errorColor = '#d71f28';

const hum5 = base({primaryColor, primary, hover, errorColor, base});
hum5.button.backgroundColor = '#f78e1e';
hum5.dateDropdown.padding = '15.6px 30px 12.4px 10px';
hum5.teaser.display = 'block';
hum5.teaser.blockBackgroundColor = 'transparent';
hum5.teaser.padding = '15px';

export default hum5;
